import {
	findID,
	listener,
	eventHandler, find, findAll, sendDynamicForm
} from "../../../../../modules/vegas/js/util";
import {Modal} from "../../../dependencies/bootstrap";
import Points from "../../points/Points";
import VGCatalogCart from "./cart";
import axios from "axios";

let instanceMap;
let modal;

let modalOrderPointsMap = findID('cart-modal-delivery-map');

function syncCurrentAddress(data) {
	let address = data.full_address || data.actual_address || '';

	if (!address) {
		return;
	}

	findAll('[data-current-address]').forEach((element) => {
		element.textContent = address;
		element.setAttribute('title', address);
	});

	findAll('[data-current-address-help]').forEach((element) => {
		element.classList.add('d-none');
	});

	findAll('.catalog-cart [data-vg-toggle="location-address-lookup"]').forEach((input) => {
		input.value = address;
	});
}

function renderPostOffice(container, postOffice, postcode = null) {
	let result = container.querySelector('[data-post-office-result]');
	let value = container.querySelector('[data-post-office]');
	let error = container.querySelector('[data-post-office-error]');
	let postcodeInput = container.querySelector('[data-postcode]');
	let postOfficeInput = container.querySelector('[data-post-office-id]');

	if (!result || !value || !error || !postcodeInput || !postOfficeInput) {
		return;
	}

	if (postcode !== null) {
		postcodeInput.value = postcode;
	}

	if (postOffice) {
		value.textContent = `${postOffice.postcode} — ${postOffice.address}`;
		value.setAttribute('href', postOffice.url);
		postOfficeInput.value = postOffice.id;
		postcodeInput.value = postOffice.postcode;
		result.classList.remove('d-none');
		error.classList.add('d-none');
	} else {
		value.textContent = '';
		value.removeAttribute('href');
		postOfficeInput.value = '';
		result.classList.add('d-none');
		error.classList.remove('d-none');
	}
}

function togglePostOffice(container) {
	let officeContainer = container.querySelector('[data-post-office-container]');
	let tariff = container.querySelector('[name^="delivery[7][post_tariff]"]:checked');

	officeContainer?.classList.toggle('d-none', tariff?.value === 'ems');
}

if (modalOrderPointsMap) {
	instanceMap = Points.getOrCreateInstance('modal-points-map');
	modal = new Modal(modalOrderPointsMap);
}

modalOrderPointsMap?.addEventListener('shown.bs.modal', function () {
	instanceMap?.request({
		company: modalOrderPointsMap.dataset.deliveryName,
		servicing_offices: modalOrderPointsMap.dataset.servicingOffices === 'true' ? 1 : 0,
	});

	setTimeout(() => {
		modalOrderPointsMap.querySelector('.modal-loader').classList.remove('fade')
	}, 400)

	setTimeout(() => {
		modalOrderPointsMap.querySelector('.modal-loader').classList.remove('show')
	}, 600)
});


listener('click', '#cart-modal-delivery-map [data-toggle="save-point"]', function (element) {
	let pointId = element.dataset.id

	Points.setPoint(instanceMap.params.points.set, {
		id: pointId,
		company: element.dataset.company,
		servicing_office: modalOrderPointsMap.dataset.servicingOffices === 'true' ? 1 : 0,
		_token: App.csrf
	}, {
		success: function (data) {
			let form = findID('form-cart');
			let name = data.name;

			if (name === 'post') {
				let container = form.querySelector('[data-delivery-additional="post"]');
				renderPostOffice(container, data, data.postcode);
				togglePostOffice(container);

				new VGCatalogCart().update({
					get_delivery_prices: true,
				});

				modal.hide();
				return;
			}

			let deliveryInfo = form.querySelector(`[data-delivery-info="${name}"]`)

			deliveryInfo.querySelector('.point_id').value = pointId;
			deliveryInfo.querySelector('[data-selected-point]').dataset.selectedPoint = data.title;

			modal.hide();
		},
		error: function (error) {
			console.error(error)
		}
	})
}, true);

listener('change', [
	'.catalog-cart [name="delivery_id"][data-delivery-name="cdek"]',
	'.catalog-cart [name="delivery_id"][data-delivery-name="pek"]',
	'.catalog-cart [name="delivery_id"][data-delivery-name="dellin"]',
], (el, e) => {
	if (!e.isTrusted || !el.closest('li').querySelector('.point_id')?.value) {
		modalOrderPointsMap.dataset.deliveryName = el.dataset.deliveryName;
		modalOrderPointsMap.dataset.servicingOffices = 'false';
		modalOrderPointsMap.querySelector('[data-points-modal-title]').textContent = 'Выберите пункт выдачи';
		modalOrderPointsMap.querySelector('[data-points-modal-description]').textContent = 'На карте показаны пункты выдачи';
		modal.show();
	}
}, true);

listener('click', [
	'.catalog-cart .delivery-area .btn-select-point',
	'.catalog-cart .delivery-area .btn-change-point',
], (el, e) => {
	let input = el.closest('.list-item').querySelector('[name="delivery_id"]');
	eventHandler.on(input, 'change');
}, true);

listener('click', '.catalog-cart [data-change-post-office]', () => {
	modalOrderPointsMap.dataset.deliveryName = 'post';
	modalOrderPointsMap.dataset.servicingOffices = 'true';
	modalOrderPointsMap.querySelector('[data-points-modal-title]').textContent = 'Выберите почтовое отделение';
	modalOrderPointsMap.querySelector('[data-points-modal-description]').textContent = 'На карте показаны отделения Почты России';
	modal.show();
}, true);

listener('change', '.catalog-cart [name=delivery_id]', function (el, event) {
	event.preventDefault();

	eventHandler.on(el.closest('.catalog-cart'), 'toggle-additionals');

	new VGCatalogCart().update();
});

listener('change', '.catalog-cart [name^="delivery[7][post_tariff]"]', function (el) {
	togglePostOffice(el.closest('[data-delivery-additional]'));

	new VGCatalogCart().update({
		get_delivery_prices: true,
	});
});

listener('toggle-additionals', '.catalog-cart', (el, e) => {
	let selectedOption = el.querySelector('[name=delivery_id]:checked'),
		deliveryName = selectedOption?.dataset.deliveryName,
		containerOrder = el
	;

	let deliveryAdditionals = findAll('[data-delivery-additional]', containerOrder);
	[...deliveryAdditionals].forEach(el => {
		el.classList.add('d-none');
		[...el.querySelectorAll('.toggle-required')].forEach(t => t.removeAttribute('required'));

		if (el.dataset.deliveryAdditional === deliveryName) {
			el.classList.remove('d-none');
			[...el.querySelectorAll('.toggle-required')].forEach(t => t.setAttribute('required', true));
		}
	});
});

listener('click', [
	'.catalog-cart [data-delivery-additional="post"] .btn-set-address',
], (el, e) => {
	let container = el.closest('[data-delivery-additional]');
	let dropdown = container.querySelector('.dropdown-lookup');
	let input = container.querySelector('[data-vg-toggle="location-address-lookup"]');
	let route = dropdown.dataset.routeSet;
	let address = input.value;

	el.innerHTML = '<i class="fa fa-spin fa-spinner"></i>';

	axios.post(route, {
		_token: App.csrf,
		address: address,
	}, {
		headers: {
			"X-Requested-With": "XMLHttpRequest",
		}
	}).then((response) => {
		el.innerHTML = 'OK';
		syncCurrentAddress(response.data);
		renderPostOffice(container, response.data.post_office, response.data.postcode);
		togglePostOffice(container);

		new VGCatalogCart().update({
			get_delivery_prices: true,
		});
	});
}, true);

listener('change', '.catalog-cart [data-vg-toggle="location-address-lookup"]', (input, e) => {
	let container = input.closest('[data-delivery-additional]');
	let dropdown = container.querySelector('.dropdown-lookup');
	let route = dropdown.dataset.routeSet;
	let address = input.value;

	axios.post(route, {
		_token: App.csrf,
		address: address,
	}, {
		headers: {
			"X-Requested-With": "XMLHttpRequest",
		}
	}).then((response) => {
		syncCurrentAddress(response.data);
		renderPostOffice(container, response.data.post_office, response.data.postcode);
		togglePostOffice(container);

		new VGCatalogCart().update({
			get_delivery_prices: true,
		});
	});
});
